package org.gymly.api.dto

import kotlinx.serialization.Serializable

/** Socio en el monitoreo de términos: estado, contacto y acciones. */
@Serializable
data class ClientTermsRowDto(
    val id: String,
    val name: String,
    val email: String? = null,
    val phone: String? = null,
    val active: Boolean = true,
    val portalAccess: Boolean = false,
    val status: String,
    val termsVersion: String? = null,
    val termsAcceptedAt: String? = null,
    val declinedVersion: String? = null,
    val declinedAt: String? = null,
    val suspensionReason: String? = null,
    val suspensionNote: String? = null,
    val suspendedAt: String? = null,
)

@Serializable
data class ClientTermsChannelsDto(
    val email: Boolean = false,
    val whatsapp: Boolean = false,
    val cooldownDays: Int = 3,
    val emailPaused: Boolean = false,
    val whatsappPaused: Boolean = false,
)

@Serializable
data class ClientTermsMonitoringDto(
    val currentVersion: String,
    val available: Boolean,
    val canOperate: Boolean = false,
    val canApprove: Boolean = false,
    val channels: ClientTermsChannelsDto = ClientTermsChannelsDto(),
    val members: List<ClientTermsRowDto> = emptyList(),
)

/** op: REACTIVATE, RESEND o SUSPEND. motivo: obligatorio solo al suspender. */
@Serializable
data class ClientTermsActionRequestDto(val op: String, val motivo: String? = null)

/** scope: PENDIENTES o IDS. channels: EMAIL y/o WHATSAPP separados por coma. */
@Serializable
data class TermsNoticeRequestDto(val scope: String, val clientIds: List<String>? = null, val channels: String)

@Serializable
data class TermsNoticeResponseDto(
    val batchId: String,
    val queued: Int,
    val noContact: Int,
    val withinCooldown: Int,
    val alreadyQueued: Int,
)

@Serializable
data class TermsNoticeProgressDto(
    val batchId: String,
    val total: Long,
    val sent: Long,
    val failed: Long,
    val pending: Long,
)
